/** Inbox https://xmpp.org/extensions/inbox/inbox.html */
export const INBOX_XMLNS = 'erlang-solutions.com:xmpp:inbox:0'
export const MUC_DOMAIN = 'conference.localhost'

/** Markers https://xmpp.org/extensions/xep-0333.html */
export const MARKERS_XMLNS = 'urn:xmpp:chat-markers:0'

/** Result Set Management https://xmpp.org/extensions/xep-0059.html */
export const PAGINATION_XMLNS = 'http://jabber.org/protocol/rsm'

/** Message Archive Management https://xmpp.org/extensions/xep-0313.html */
export const MAM_XMLNS = 'urn:xmpp:mam:2'

/** Stream Management https://xmpp.org/extensions/xep-0198.html */
export const SM_XMLNS = 'urn:xmpp:sm:3'

/** MUC Light https://esl.github.io/MongooseDocs/latest/open-extensions/muc_light/ */
const MUC_LIGHT_XMLNS = 'urn:xmpp:muclight:0'
export const MUC_LIGHT_AFFILIATIONS = `${MUC_LIGHT_XMLNS}#affiliations`
